import React, {ReactNode, useCallback, useEffect} from "react"
import {useScrollTrigger} from "@mui/material"
import {useDispatch} from "react-redux"
import {useModalsCloseObservable} from "@next/eventservice"
import {breakpoints} from "@next/ux-fabric"
import {Action, ThunkDispatch} from "@reduxjs/toolkit"
import Cookies from "js-cookie"
import connect from "./connect"
import {OuterContainer} from "./component"
import {closeAllPanels} from "../../ducks/search"
import {updateRecentQueries} from "../../ducks/recents"
import {
    VISITED_PAGES,
    SESSION_STORAGE_ACTIVE_DEPT_NAME,
    SEARCH_BLUR_BREAKPOINT,
    STICKY_HEADER_SCROLL_TRIGGER,
} from "../../config/constants"
import {useMediaQuery} from "../../hooks/useMediaQuery"
import State from "../../ducks/state"

export type UpperHeaderProps = {
    children?: ReactNode
    mobileHeight: number
    desktopHeight: number
    showAutoComplete: boolean
    showRecentSearch: boolean
    isCloseAllPanels?: boolean
}

export const UpperHeaderWrapper = ({
    children,
    mobileHeight,
    desktopHeight,
    showAutoComplete,
    showRecentSearch,
    isCloseAllPanels = true,
}: UpperHeaderProps) => {
    const dispatch = useDispatch<ThunkDispatch<State, null, Action>>()
    const hide = useScrollTrigger({threshold: STICKY_HEADER_SCROLL_TRIGGER})
    const isMobile = useMediaQuery(`(max-width:${breakpoints.values.md - 1}px)`)
    const forceShow = isMobile && (showAutoComplete || showRecentSearch)

    const closePanelsOnBlur = useMediaQuery(`(min-width:${SEARCH_BLUR_BREAKPOINT})`)

    useModalsCloseObservable(closeAllPanels)

    useEffect(() => {
        const visitedPages = JSON.parse(localStorage.getItem(VISITED_PAGES) || "[]")
        if (visitedPages.length > 3) {
            Cookies.remove(SESSION_STORAGE_ACTIVE_DEPT_NAME)
            localStorage.removeItem(VISITED_PAGES)
        } else {
            visitedPages.push({depth: visitedPages.length})
            localStorage.setItem(VISITED_PAGES, JSON.stringify(visitedPages))
        }
    }, [])

    useEffect(() => {
        window.requestIdleCallback(() => {
            dispatch(updateRecentQueries())
        })
    }, [dispatch])

    const handleClick = useCallback(() => {
        if (!(closePanelsOnBlur && isCloseAllPanels)) return
        dispatch(closeAllPanels())
    }, [dispatch, closePanelsOnBlur])

    return (
        <OuterContainer
            hide={hide && !forceShow}
            data-testid="header-upperheader"
            isMobile={isMobile}
            onClick={handleClick}
            desktopHeight={desktopHeight}
            mobileHeight={mobileHeight}
        >
            {children}
        </OuterContainer>
    )
}

export default connect(UpperHeaderWrapper)
